import { InventoryEntryDetailPrintModel } from "./inventory-entry-detail-print.model";

export class InventoryEntryPrintModel {
  inventoryEntryId: number = 0;
  companyId: number = 0;
  enterpriseId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseNit: string = "";
  enterpriseName: string = "";
  inventoryId: number = 0;
  inventoryCode: string = "";
  inventoryName: string = "";
  branchId: number = 0;
  branchCode: string = "";
  branchName: string = "";
  address: string = "";
  phone: string = "";
  consecutive: string = "";
  dateEntry: Date = new Date();
  inventoryEntryStateId: number = 0;
  inventoryEntryState: string = "";
  conceptCode: string = "";
  conceptName: string = "";
  provider: string = "";
  remission: string | null = null;
  invoice: string | null = null;
  observation: string | null = null;
  inventoryEntryDetails: InventoryEntryDetailPrintModel[] = [];
}